import { useTheme } from "@mui/system";

export default function MaterialsIcon() {
  const theme = useTheme();
  return (
    <svg width="20" height="20" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg">
      {/* Стопка документов: раздел собирает памятки и документы клиники */}
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M3.33398 4.1665V15.8332C3.33398 17.2139 4.45328 18.3332 5.83398 18.3332H14.1673C15.5481 18.3332 16.6673 17.2139 16.6673 15.8332V7.49984C16.6673 6.11913 15.5481 4.99984 14.1673 4.99984H4.16732C3.70708 4.99984 3.33398 4.62674 3.33398 4.1665ZM6.04232 9.99984C6.04232 9.65467 6.32214 9.37484 6.66732 9.37484H13.334C13.6792 9.37484 13.959 9.65467 13.959 9.99984C13.959 10.345 13.6792 10.6248 13.334 10.6248H6.66732C6.32214 10.6248 6.04232 10.345 6.04232 9.99984ZM6.04232 12.9165C6.04232 12.5713 6.32214 12.2915 6.66732 12.2915H11.2507C11.5958 12.2915 11.8757 12.5713 11.8757 12.9165C11.8757 13.2617 11.5958 13.5415 11.2507 13.5415H6.66732C6.32214 13.5415 6.04232 13.2617 6.04232 12.9165Z"
        fill={theme.palette.rgd.primary}
      />
      <path
        d="M3.67383 3.40592C3.96423 3.53615 4.1665 3.82778 4.1665 4.16667H14.1665C14.4543 4.16667 14.7335 4.20312 14.9998 4.27168V3.58837C14.9998 2.57412 14.1015 1.79502 13.0975 1.93845L4.09949 3.22387C3.9391 3.24679 3.79376 3.31145 3.67383 3.40592Z"
        fill={theme.palette.rgd.primary}
      />
    </svg>
  );
}